import React from 'react';
import { resolveAssetUrl } from '../utils/resolveUrl';

export default function ProductLoanBadge({ loanInfo, placement = 'card', isPreview = false, customStyle = {} }) {
  if (!loanInfo || !loanInfo.isEligible) return null;

  let cfg;
  if (placement === 'productView') {
    if (!loanInfo.productView?.showBadge) return null;
    cfg = {
      position: loanInfo.productView.badgePosition || 'top-left',
      offsetX: loanInfo.productView.badgeOffsetX ?? 10,
      offsetY: loanInfo.productView.badgeOffsetY ?? 10,
      bgColor: loanInfo.productView.badgeBgColor || '#007da5',
      textColor: loanInfo.productView.badgeTextColor || '#ffffff',
      text: loanInfo.productView.badgeText,
      fontSize: 11,
      fontWeight: 700,
      borderRadius: 6,
      shadow: true
    };
  } else {
    // Card placement
    if (!loanInfo.card?.enabled) return null;
    if (loanInfo.card.displayMode === 'subprice') return null; // Only show if mode is 'badge' or 'both'
    cfg = {
      position: loanInfo.card.position || 'top-left',
      offsetX: loanInfo.card.offsetX ?? 10,
      offsetY: loanInfo.card.offsetY ?? 10,
      bgColor: loanInfo.card.bgColor || '#007da5',
      textColor: loanInfo.card.textColor || '#ffffff',
      text: loanInfo.card.badgeText,
      fontSize: loanInfo.card.fontSize || 11,
      fontWeight: loanInfo.card.fontWeight || 700,
      borderRadius: loanInfo.card.borderRadius || 6,
      shadow: loanInfo.card.shadow !== false
    };
  }

  const posStyle = {};
  if (cfg.position === 'top-right') {
    posStyle.top = `${Number(cfg.offsetY) || 0}px`;
    posStyle.right = `${Number(cfg.offsetX) || 0}px`;
  } else if (cfg.position === 'bottom-left') {
    posStyle.bottom = `${Number(cfg.offsetY) || 0}px`;
    posStyle.left = `${Number(cfg.offsetX) || 0}px`;
  } else if (cfg.position === 'bottom-right') {
    posStyle.bottom = `${Number(cfg.offsetY) || 0}px`;
    posStyle.right = `${Number(cfg.offsetX) || 0}px`;
  } else {
    // top-left
    posStyle.top = `${Number(cfg.offsetY) || 0}px`;
    posStyle.left = `${Number(cfg.offsetX) || 0}px`;
  }

  const wrapperStyle = {
    position: 'absolute',
    ...posStyle,
    zIndex: 13,
    pointerEvents: isPreview ? 'auto' : 'none',
    userSelect: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    maxWidth: 'calc(100% - 14px)',
    transition: 'all 0.15s ease',
    ...customStyle
  };

  const badgeStyle = {
    backgroundColor: cfg.bgColor,
    color: cfg.textColor,
    fontSize: `${Number(cfg.fontSize) || 11}px`,
    fontWeight: Number(cfg.fontWeight) || 700,
    borderRadius: `${Number(cfg.borderRadius) || 6}px`,
    padding: '4px 8px',
    boxShadow: cfg.shadow ? '0 3px 8px rgba(0,0,0,0.2)' : 'none',
    lineHeight: 1.25,
    whiteSpace: 'nowrap',
    letterSpacing: '0.3px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6
  };

  const partnerLogoUrl = loanInfo.partnerLogo ? resolveAssetUrl(loanInfo.partnerLogo) : null;

  return (
    <div className="product-loan-badge-container" style={wrapperStyle} title={loanInfo.ruleName || 'Kredi me Këste'}>
      <span style={badgeStyle}>
        {partnerLogoUrl ? (
          <img
            src={partnerLogoUrl}
            alt={loanInfo.partnerName || 'Logo'}
            style={{ height: 14, maxWidth: 38, objectFit: 'contain', display: 'inline-block', filter: 'brightness(1.1)' }}
          />
        ) : (
          <span style={{ fontSize: '1.05em', lineHeight: 1 }}>💳</span>
        )}
        <span>{cfg.text}</span>
      </span>
    </div>
  );
}
